import type { Models } from '@rematch/core';
import { CaixaBancoModel } from './caixa-banco';
import { CobrancaBoletoModel } from './cobranca-boleto';
import { ContasPagarModel } from './contas-pagar';
import { ContasReceberModel } from './contas-receber';
import { CuponsFiscaisModel } from './cupom-fiscal';
import { NotaFiscalModel } from './nota-fiscal';
import { RomaneioModel } from './romaneio';
import { VendasExternasModel } from './vendas-externas';

export interface RootModel extends Models<RootModel> {
    caixaBanco: typeof CaixaBancoModel;
    cobrancaBoleto: typeof CobrancaBoletoModel;
    contasReceber: typeof ContasReceberModel;
    contasPagar: typeof ContasPagarModel;
    cuponsFiscais: typeof CuponsFiscaisModel;
    notaFiscal: typeof NotaFiscalModel;
    romaneio: typeof RomaneioModel;
    vendasExternas: typeof VendasExternasModel;
}

export const models: RootModel = {
    caixaBanco: CaixaBancoModel,
    cobrancaBoleto: CobrancaBoletoModel,
    contasPagar: ContasPagarModel,
    contasReceber: ContasReceberModel,
    cuponsFiscais: CuponsFiscaisModel,
    notaFiscal: NotaFiscalModel,
    romaneio: RomaneioModel,
    vendasExternas: VendasExternasModel,
};
